export default __webpack_public_path__ + "static/media/chat-2.d6430e1a.JPG";